import { render, staticRenderFns } from "./japanese-katakana.vue?vue&type=template&id=a89e98a2&scoped=true&"
import script from "./japanese-katakana.vue?vue&type=script&lang=js&"
export * from "./japanese-katakana.vue?vue&type=script&lang=js&"
import style0 from "./japanese-katakana.vue?vue&type=style&index=0&id=a89e98a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89e98a2",
  null
  
)

export default component.exports